import { useFilterPackageContext } from "./filter-package.context";

export function FilterPackage() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterPackageContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}